/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Which competition types this game supports
 * @export
 * @interface CompetitionConfigEnabledTypes
 */
export interface CompetitionConfigEnabledTypes {
    /**
     * Leaderboards - requires auto-scoring
     * @type {boolean}
     * @memberof CompetitionConfigEnabledTypes
     */
    leaderboards?: boolean;
    /**
     * Challenges (1v1, Arena) - can be auto or manual
     * @type {boolean}
     * @memberof CompetitionConfigEnabledTypes
     */
    challenges?: boolean;
    /**
     * Bracket tournaments - can be auto or manual
     * @type {boolean}
     * @memberof CompetitionConfigEnabledTypes
     */
    tournaments?: boolean;
    /**
     * Ladders/rankings - can be auto or manual
     * @type {boolean}
     * @memberof CompetitionConfigEnabledTypes
     */
    ladders?: boolean;
    /**
     * Leagues - seasonal competitions
     * @type {boolean}
     * @memberof CompetitionConfigEnabledTypes
     */
    leagues?: boolean;
    /**
     * Guild competitions - team/guild based
     * @type {boolean}
     * @memberof CompetitionConfigEnabledTypes
     */
    guilds?: boolean;
}

/**
 * Check if a given object implements the CompetitionConfigEnabledTypes interface.
 */
export function instanceOfCompetitionConfigEnabledTypes(value: object): value is CompetitionConfigEnabledTypes {
    return true;
}

export function CompetitionConfigEnabledTypesFromJSON(json: any): CompetitionConfigEnabledTypes {
    return CompetitionConfigEnabledTypesFromJSONTyped(json, false);
}

export function CompetitionConfigEnabledTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionConfigEnabledTypes {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboards': json['leaderboards'] == null ? undefined : json['leaderboards'],
        'challenges': json['challenges'] == null ? undefined : json['challenges'],
        'tournaments': json['tournaments'] == null ? undefined : json['tournaments'],
        'ladders': json['ladders'] == null ? undefined : json['ladders'],
        'leagues': json['leagues'] == null ? undefined : json['leagues'],
        'guilds': json['guilds'] == null ? undefined : json['guilds'],
    };
}

export function CompetitionConfigEnabledTypesToJSON(json: any): CompetitionConfigEnabledTypes {
    return CompetitionConfigEnabledTypesToJSONTyped(json, false);
}

export function CompetitionConfigEnabledTypesToJSONTyped(value?: CompetitionConfigEnabledTypes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboards': value['leaderboards'],
        'challenges': value['challenges'],
        'tournaments': value['tournaments'],
        'ladders': value['ladders'],
        'leagues': value['leagues'],
        'guilds': value['guilds'],
    };
}

